<header id="header">
  <div class="topbar">
    <div class="topbar-content">
      <div class="topbar-display-elements">
        <div class="topbar-left" #topbarLogo>
          <!-- Logo inséré depuis component.ts -->
        </div>
        <div class="topbar-right topbar-signout" (click)="openSignoutDialog()">
          <!-- Nouveau conteneur pour le nom et le numéro de version -->
          <div class="user-info">
            <div class="topbar-display-name">
              {{ displayNameAndLastName() }}
            </div>
            <div class="topbar-display-version">
              v{{ version }}
            </div>
          </div>
          <div>
            <i class="material-icons">
              exit_to_app
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
  
<ags-signout-dialog 
  [dialogOpened]="dialogOpened"
  [dialogErrorMessage]="dialogErrorMessage"
  [loadingRequest]="loadingRequest"
  [themingClassName]="themingClassName"
  (closeDialog)="closeDialog($event)"></ags-signout-dialog>